export default __webpack_public_path__ + "static/media/DNo.27-3.561e84f0.jpg";